export interface Colour {
    text: string;
    value: string|null;
}

export const ColourValues: {[value: string]: string|null} = {
    '(Default)':    null,
    'Black':        'black',
    'Blue':         'blue',
    'Cyan':         'cyan',
    'DarkBlue':     '#00008b',  //'darkblue', - named colours were not always recognised, so in some cases replaced with their colour codes
    'DarkCyan':     '#008b8b',  //'darkcyan',
    'DarkGray':     '#a9a9a9',  //'darkgray',
    'DarkGreen':    '#006400',  //'darkgreen',
    'DarkMagenta':  '#8b008b',  //'darkmagenta',
    'DarkRed':      '#8b0000',  //'darkred',
    'DarkYellow':   '#9b870c',  //'#646400', - the "official" darkyellow is x9b870c, not x646400
    'Green':        'green',
    'LightGray':    '#d3d3d3',  //'lightgray',
    'Magenta':      '#ff00ff',  //'magenta',
    'Red':          'red',
    'White':        'white',
    'Yellow':       'yellow',
    'Orange':       '#ff5000'
}

export const DefaultColour = Object.keys(ColourValues)[0]

// Use a smaller palette of brighter (ie rainbow) colours for waypoint icons,
// as the other palette (for routes) has many that are dark.
export const IconColours: {[value: string]: string|null} = {
    'Red':      '#E53935',
    'Orange':   '#ff5000',
    'Yellow':   '#FDD835',
    'Green':    'green',
    'Blue':     'blue',
    'Indigo':   'indigo',
    'Violet':   '#8F00FF',
    'White':    'white',
    'Black':    'black',
}
